// extracted by mini-css-extract-plugin
export default {"prizesContainer":"IRdqlQZmdvHobsaDfcbu","prizeItem":"Ws7VkjuKQpiNyKnBnGwP","title":"n96OD9SvzcX1K3XSKrxh"};